import { StylesConfig } from 'react-select';

export const getReactSelectStyles = <Option = any, IsMulti extends boolean = false>(compact = false): StylesConfig<Option, IsMulti> => ({
    control: (provided, state) => ({
        ...provided,
        backgroundColor: 'var(--bs-body-bg)',
        borderColor: state.isFocused ? 'var(--bs-primary)' : 'var(--bs-border-color)',
        borderRadius: '0.5rem',
        color: 'var(--bs-body-color)',
        minHeight: compact ? '30px' : provided.minHeight,
        height: compact ? '30px' : provided.height,
        fontSize: compact ? '0.9rem' : provided.fontSize,
        boxShadow: state.isFocused ? '0 0 0 0.25rem rgba(99, 102, 241, 0.25)' : undefined,
        '&:hover': {
            borderColor: state.isFocused ? 'var(--bs-primary)' : 'var(--bs-border-color)',
        },
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: compact ? '0 8px' : provided.padding,
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        height: compact ? '30px' : provided.height,
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: 'var(--bs-body-bg)',
        borderColor: 'var(--bs-border-color)',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: '0.5rem',
        overflow: 'hidden',
        boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.15)',
        zIndex: 9999,
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px 0',
        backgroundColor: 'var(--bs-body-bg)',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? 'var(--bs-primary)'
            : state.isFocused
            ? 'var(--bs-tertiary-bg)'
            : 'transparent',
        color: state.isSelected
            ? '#ffffff'
            : 'var(--bs-body-color)',
        cursor: state.isDisabled ? 'not-allowed' : 'default',
        '&:active': {
            backgroundColor: 'var(--bs-secondary-bg)',
        },
    }),
    singleValue: (provided) => ({
        ...provided,
        color: 'var(--bs-body-color)',
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: 'var(--bs-secondary-bg)',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: 'var(--bs-body-color)',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: 'var(--bs-secondary-color)',
        '&:hover': {
            backgroundColor: 'var(--bs-danger)',
            color: '#ffffff',
        },
    }),
    input: (provided) => ({
        ...provided,
        color: 'var(--bs-body-color)',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: 'var(--bs-secondary-color)',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        backgroundColor: 'var(--bs-border-color)',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: 'var(--bs-secondary-color)',
        '&:hover': {
            color: 'var(--bs-body-color)',
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: 'var(--bs-secondary-color)',
        '&:hover': {
            color: 'var(--bs-body-color)',
        },
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: 'var(--bs-secondary-color)',
    }),
});
